import React from 'react';
import { APP_BASE_URL } from '../../../config';
import { formatTimeAgo, formatExactDate } from '@utils/timeUtils';

const stringifyTime = ({ week = 0, day = 0, hours = 0, minute = 0 }) => {
  let str = '';
  if (week) str += `${week}w `;
  if (day) str += `${day}d `;
  if (hours) str += `${hours}h `;
  if (minute) str += `${minute}m`;
  return str.trim();
};

const parseTimeInput = (spend_time) => {
  const { week = 0, day = 0, hours = 0, minute = 0 } = JSON.parse(spend_time || '{}');
  return { week, day, hours, minute };
};

const WorkLogItem = ({ log }) => {
  const timeObj = parseTimeInput(log.spend_time);
  const timeStr = stringifyTime(timeObj);
  const exactDate = log.log_date ? formatExactDate(log.log_date) : '-';
  const relativeTime = log.log_date ? formatTimeAgo(log.log_date) : '';
  const name = log.name || 'Unknown';
  const photo = log.photo;
  const userId = log.user_id;

  const avatar = photo
    ? `${APP_BASE_URL}/uploads/profilephoto/${userId}/profilePic/${photo}`
    : null;

  const initials = name
    ? name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()
    : 'U';

  return (
    <div className="flex items-start gap-3 mb-6 relative">
      {/* Timeline Line */}
      <div className="w-10 flex justify-center relative">
        <div className="absolute top-0 bottom-0 left-1/2 border-l-2 border-gray-200 transform -translate-x-1/2" />
        {/* Avatar */}
        {avatar ? (
          <img
            src={avatar}
            alt={name}
            className="relative z-10 w-8 h-8 rounded-full object-cover border bg-white"
          />
        ) : (
          <div className="relative z-10 w-8 h-8 bg-gray-400 rounded-full flex items-center justify-center text-white font-semibold text-xs">
            {initials}
          </div>
        )}
      </div>

      {/* Log Content */}
      <div className="flex-1">
        <div className="text-sm text-gray-800">
          <strong>{timeStr}</strong> logged
        </div>
        {log.note && (
          <div
            className="prose prose-sm max-w-none bg-gray-50 rounded px-3 py-2 mt-1 text-gray-700"
            dangerouslySetInnerHTML={{ __html: log.note }}
          />
        )}
        <div className="text-xs text-gray-500 mt-1 flex items-center gap-2">
          <span>By <strong>{name}</strong></span>
          <span title={exactDate}>{relativeTime}</span>
        </div>
      </div>
    </div>
  );
};

export default WorkLogItem;
